import { FormEvent, useState } from "react";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Modal,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Main.css";

export default function MainPage() {
  const [inputText, setInputText] = useState<string>("");
  const [outputText, setOutputText] = useState<string>("");
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showToast, setShowToast] = useState<boolean>(false);
  const [showForm, setShowForm] = useState<boolean>(true);
  const [incidentNumber, setIncidentNumber] = useState<string>("");

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setShowToast(true);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setErrorMessage("複製失敗，請重試");
      setShowErrorModal(true);
    }
  };

  const convertText = (text: string): string | null => {
    const timestampMatch = text.match(
      /Alarm Timestamp:\s*(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}):\d{2}/i,
    );

    const alarmNameMatch = text.match(
      /Alarm Name:\s*(.+?)(?=\s*Alarm Priority:|$)/i,
    );

    if (!timestampMatch || !alarmNameMatch) {
      setErrorMessage(
        "輸入格式不正確，請確保包含 Alarm Timestamp 和 Alarm Name",
      );
      setShowErrorModal(true);
      return null;
    }

    const [, date, time] = timestampMatch;
    const alarmName = alarmNameMatch[1].trim();

    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const [hours, minutes] = time.split(":").map(Number);
    const dateTime = new Date();
    dateTime.setHours(hours);
    dateTime.setMinutes(minutes + 1);
    const formattedTechTime = dateTime.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    return `${formattedDate}\nIncident Number: TBC\n${time} BMS received ${alarmName}\n${formattedTechTime} BDx Technicians are going to the site for inspection`;
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const result = convertText(inputText);
    if (result) {
      setOutputText(result);
      await copyToClipboard(result);
      setShowForm(false);
    } else {
      setOutputText("");
    }
  };

  const handleCopy = async () => {
    if (outputText) {
      await copyToClipboard(outputText);
    }
  };

  const handleCloseModal = () => {
    setShowErrorModal(false);
    setErrorMessage("");
  };

  const handleCloseToast = () => {
    setShowToast(false);
  };

  const handleSendEmail = () => {
    if (outputText) {
      const updatedOutput = outputText.replace("TBC", incidentNumber || "TBC");
      const emailBody = `Hi Support\n\n${updatedOutput}\n\nBest regards,\nFMT HKG8 NOC`;
      const mailtoUrl = `mailto:support@bdxworld.com?cc=fmt.hkg8@bdxworld.com&subject=HKG8 Incident Report - ${incidentNumber || "TBC"}&body=${encodeURIComponent(emailBody)}`;
      window.location.href = mailtoUrl;
    }
  };

  return (
    <Container className="Main d-flex flex-column justify-content-center align-items-center mt-4">
      {showForm && (
        <Row className="justify-content-center w-100">
          <Col md={8} lg={6}>
            <h2 className="text-center mb-4">回報 BMS Alarm</h2>
            <div className="form-container">
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formInputText" className="mb-3">
                  <Form.Label>輸入電郵內容</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                    placeholder="請輸入 Alarm Timestamp"
                    required
                  />
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100">
                  提交
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      )}

      {outputText && (
        <Row className="justify-content-center w-100 mt-4">
          <Col md={8} lg={6}>
            <h4 className="text-center">回報 Alarm</h4>
            <pre className="border p-3 bg-light">{outputText}</pre>

            <div className="action-row">
              <div></div>
              <div className="btn-group">
                <Button variant="secondary" onClick={handleCopy}>
                  複製
                </Button>
              </div>
            </div>

            <br />
            <br />
            <br />

            <h4 className="text-center">Incident Number</h4>
            <div className="action-row">
              <Form.Control
                type="text"
                value={incidentNumber}
                onChange={(e) => setIncidentNumber(e.target.value)}
                placeholder="輸入 Incident Number"
              />

              <div className="btn-group">
                <Button variant="success" onClick={handleSendEmail}>
                  發送郵件
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      )}

      <Modal show={showErrorModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-end" className="p-3">
        <Toast
          show={showToast}
          onClose={handleCloseToast}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">通知</strong>
          </Toast.Header>
          <Toast.Body>文字已成功複製！</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
}
